<template>
  <FlotoModule>
    <template v-if="hasPermission">
      <RouterView :key="$route.fullPath" />
    </template>
  </FlotoModule>
</template>

<script>
import { PreferenceComputed } from '@state/modules/preference'
import { LicenseComputed } from '@state/modules/license'
export default {
  name: 'WorkflowModule',
  page() {
    return {
      title: this.$t('workflow'),
    }
  },
  data() {
    return {
      hasPermission: false,
    }
  },
  computed: {
    ...LicenseComputed,
    ...PreferenceComputed,
  },
  created() {
    // if user doesn't have permission to handle admin automation section
    if (
      this.myAllowedModules.indexOf('admin.asset_discovery') === -1 &&
      this.myAllowedModules.indexOf('admin.cmdb_discovery') === -1
    ) {
      return this.$router.replace({ name: '404' })
    }
    this.hasPermission = true
  },
}
</script>

<style lang="less" src="@src/design/workflow.less"></style>
